import ApiService from "@/core/services/api.service";
import { SET_ERROR } from "@/core/services/store/auth.module";
export const ADD_REENTRUSTMENT_MANAGEMENT = "addDeentrustmentManagement";
// mutation types
export const GET_LIST_COST = "listCost";
export const SET_LIST_COST = "setListCost";
export const SET_SUCCESS = "SetSuccess";
export const GET_SUCCESSFUL = "listCost";
export const ADD_COST = "addCost";

const state = {
    errors: null,
    success: null,
    listCost: [],
};

const getters = {
    getListCost(state) {
        return state.listCost;
    },
    getSuccessful(state) {
        return state.success;
    }
};


const mutations = {
    [SET_LIST_COST](state, listCost) {
        state.listCost = listCost;
    },
    [SET_SUCCESS](state, code) {
        state.success = code;
    }

};


const actions = {
    [GET_LIST_COST](context, active) {
        return new Promise(resolve => {
            ApiService.get(`admin/business-manager/list-cost${active ? "-active" : ''}`)
                .then(({ data }) => {
                    if (data.data) {
                        context.commit(SET_LIST_COST, data.data);
                    }
                    resolve(data);
                })
                .catch(response => {
                    context.commit(SET_ERROR, response);
                });
        });
    },
}



export default {
    state,
    actions,
    mutations,
    getters
};
